import { db } from '../firebase/firebase.config';
import { collection, addDoc, serverTimestamp, doc, getDoc } from 'firebase/firestore';

// Cache simple del casino para evitar leerlo en cada consulta
let casinoCache = { id: null, data: null };

async function getCasinoData(casinoId) {
  if (!casinoId) return null;
  if (casinoCache.id === casinoId && casinoCache.data) return casinoCache.data;
  try {
    const snap = await getDoc(doc(db, `casinos/${casinoId}`));
    if (snap.exists()) {
      const data = { id: casinoId, nombre: snap.data().nombre || '' };
      casinoCache = { id: casinoId, data };
      return data;
    }
  } catch (e) {
    console.warn('[logConsulta] no se pudo leer casino:', e?.message);
  }
  return { id: casinoId, nombre: '' };
}

/**
 * Registra una consulta a la base de autoexcluidos.
 *
 * @param {Object} args
 * @param {Object} args.authUser - { uid, email, rol, casino (id) }
 * @param {string} args.tipoAccion - 'buscar-dni' | 'buscar-nombre' | 'escanear-qr' | 'ver-detalle'
 * @param {string} args.valorBusqueda - lo que se buscó (DNI o nombre)
 * @param {Object} args.resultado - { encontrado, tipo, cantidad, dniEncontrado }
 *
 * @throws Si la escritura del log falla — el llamador debe abortar la operación
 *         para garantizar que toda consulta queda registrada.
 */
export async function logConsulta({ authUser, tipoAccion, valorBusqueda, resultado }) {
  if (!authUser?.uid) {
    throw new Error('logConsulta: falta authUser.uid');
  }

  const casinoData = await getCasinoData(authUser.casino);

  const docData = {
    usuario: {
      uid: authUser.uid,
      email: authUser.email || '',
      rol: authUser.rol || 'user',
    },
    casino: casinoData,
    tipoAccion,
    valorBusqueda: String(valorBusqueda || ''),
    resultado: {
      encontrado: Boolean(resultado?.encontrado),
      tipo: resultado?.tipo || 'ninguno',
      cantidad: Number(resultado?.cantidad || 0),
      dniEncontrado: resultado?.dniEncontrado || null,
    },
    userAgent: (typeof navigator !== 'undefined' && navigator.userAgent) || '',
    timestamp: serverTimestamp(),
  };

  await addDoc(collection(db, 'consultas_autoexcluidos'), docData);
}
